import React from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import styles from '../../../../styles'
import { WHITE } from '../../../../theme'
import Button from '../../../../components/button/Button'

const useStyles = makeStyles(
	(theme) => ({
		popInContainerStyle: {
			padding: '31px 29px 38px 54px',
			position: 'relative'
		},
		iconStyle: {
			maxWidth: 'fit-content',
			position: 'absolute',
			top: 31,
			right: 29,

			'& svg': {
				'&:hover': {
					background: theme.palette.blue['90']
				},
				padding: 12,
				borderRadius: '100%',
				color: WHITE,
				backgroundColor: theme.palette.blue.main,
				cursor: 'pointer'
			}
		},
		titre: {
			...styles(theme).title0,
			fontSize: 35,
			lineHeight: '45px',
			marginTop: 35
		},
		texte: {
			...styles(theme).text1,
			fontSize: 16,
			lineHeight: '23px',
			marginTop: 25,
			marginBottom: 27
		},
		boutonFermer: {
			borderRadius: 25
		}
	})
)

interface AcceptingProps {
	onClose: () => void,
	error_id: string
}

const PopinConfirmationErreurRDV: React.FC<AcceptingProps> = (
	{
		onClose,
		error_id = 'visites.popin.confirmationErreurRDV.popinErreur.default',
	}
) => {
	const classes = useStyles()

	return (
		<Grid container className={classes.popInContainerStyle}>
			{/* Titre de la popin */}
			<Grid container item xs={12} className={classes.titre}>
				<FormattedMessage
					id={`${error_id}.titre`}
					defaultMessage="Réservation indisponible"
					description="Titre de la popin d'erreur lors de la confirmation du RDV"
				/>
			</Grid>

			{/* Bloc d'indication de l'espace où l'on peut retrouver le rdv */}
			<Grid container item xs={12} className={classes.texte}>
				<FormattedMessage
					id={`${error_id}.texte`}
					defaultMessage="La réservation sur ce créneau n'est pas possible pour l'instant. Nous allons actualiser les disponibilités pour vous permettre de sélectionner un autre horaire."
					description="Texte de la popin d'erreur lors de la confirmation du RDV"
				/>
			</Grid>

			{/* Bloc des boutons */}
			<Grid container item xs={12}>
				<Button
					background="backgroundAccessibility"
					color="colorWhite"
					textStyle="text8"
					size="mediumButton"
					onClick={onClose}
					buttonStyle={classes.boutonFermer}
				>
					<FormattedMessage
						id="global.btn.close"
						defaultMessage="Fermer"
						description="close"
					/>
				</Button>
			</Grid>
		</Grid>
	)
}

export default PopinConfirmationErreurRDV
